import { TaskStatus } from '@droidmap/project-service-contract'

import type { Accent } from './accent'

export const TASK_STATUS_LABEL: Record<TaskStatus, string> = {
  [TaskStatus.PENDING]: 'Queued',
  [TaskStatus.RUNNING]: 'Running',
  [TaskStatus.COMPLETED]: 'Completed',
  [TaskStatus.FAILED]: 'Failed',
  [TaskStatus.CANCELLED]: 'Cancelled',
}

export const TASK_STATUS_TONE: Record<TaskStatus, Accent> = {
  [TaskStatus.PENDING]: 'neutral',
  [TaskStatus.RUNNING]: 'warning',
  [TaskStatus.COMPLETED]: 'success',
  [TaskStatus.FAILED]: 'danger',
  [TaskStatus.CANCELLED]: 'neutral',
}

/** Statuses that are not yet terminal — used to drive polling and "processing" labels. */
export const NON_TERMINAL_TASK_STATUSES: readonly TaskStatus[] = [
  TaskStatus.PENDING,
  TaskStatus.RUNNING,
]
